var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('block',{ref:"buser",staticClass:"soft-control",attrs:{"nobody":true}},[_c('soft-table',{ref:"soft-table",staticClass:"table align-items-center table-flush",attrs:{"tbody-classes":"list","pending":false,"dataTable":_vm.productSpecifys,"fields":_vm.fields,"minHeight":_vm.$hMainContent - 64,"showAll":true,"norecordAdd":_vm.handleAddNew,"noDelete":true,"contextMenus":[
        {
          key: 'new',
          icon: 'fa-plus',
          label: 'Thêm mới'
        },
        {
          key: 'spec_feature',
          icon: 'fa-atom',
          label: 'Thông số kỹ thuật'
        },
        {
          key: 'copy',
          icon: 'fa-copy',
          label: 'Copy dòng này'
        },
        {
          key: 'edit',
          icon: 'fa-edit',
          label: 'Chỉnh sửa dòng này'
        },
        {
          key: 'init',
          icon: 'fa-plug',
          label: 'Thêm sản phẩm không qua sản xuất'
        }
      ]},on:{"rowSelected":_vm.tbSetRowSelected,"rowClicked":_vm.tbRowClicked,"doEditRow":_vm.handleEdit,"contextMenuItemClick":_vm.tbHandleContextMenuItemClick},scopedSlots:_vm._u([{key:"cell(name)",fn:function(ref){
      var value = ref.value;
      var item = ref.item;
return [_c('span',{staticClass:"mx-1 text-center"},[_vm._v(_vm._s(item.id)+" - "+_vm._s(item.unit))])]}},{key:"cell(unitHank)",fn:function(ref){
      var value = ref.value;
      var item = ref.item;
return [_c('span',[_vm._v(_vm._s(value)+" "+_vm._s(_vm.$ucWord(item.unit))+"/Cuộn ")])]}},{key:"cell(unitBag)",fn:function(ref){
      var value = ref.value;
      var item = ref.item;
return [_c('span',[_vm._v(_vm._s(value)+" "+_vm._s(_vm.$ucWord(item.unit))+"/Bịch ")])]}},{key:"cell(unitSack)",fn:function(ref){
      var value = ref.value;
      var item = ref.item;
return [_c('span',[_vm._v(_vm._s(value)+" "+_vm._s(_vm.$ucWord(item.unit))+"/Bao ")])]}},{key:"cell(quota)",fn:function(ref){
      var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value)+" ")])]}},{key:"cell(hankBag)",fn:function(ref){
      var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value)+" Cuộn/bịch")])]}},{key:"cell(hankSack)",fn:function(ref){
      var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value)+" Cuộn/bao")])]}},{key:"cell(bagSack)",fn:function(ref){
      var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value)+" Bịch/bao")])]}},{key:"cell(elastic)",fn:function(ref){
      var value = ref.value;
return [_c('span',[_vm._v(_vm._s(value))])]}},{key:"cell(userVerify)",fn:function(ref){
      var value = ref.value;
return [(value.id)?_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(value.username))]):_c('span',{staticClass:"badge badge-danger"},[_vm._v("Chưa được duyệt")])]}},{key:"cell(userManage)",fn:function(ref){
      var value = ref.value;
return [(value.id)?_c('span',{staticClass:"badge badge-info"},[_vm._v(_vm._s(value.username))]):_c('span',{staticClass:"badge badge-danger"},[_vm._v("Chưa có người hỗ trợ")])]}},{key:"action",fn:function(ref){
      var item = ref.item;
return [_c('b-button',{attrs:{"variant":"primary px-1 py-0"},on:{"click":function($event){return _vm.tbRowHandleFeatureInfo(item)}}},[_c('i',{staticClass:"fa fa-atom"}),_vm._v(" Thông số kỹ thuật")])]}}])}),_c('div',{staticClass:"p-1"},[_c('control-mini',{attrs:{"countChecked":_vm.countChecked,"noDelete":true},on:{"doAddNew":_vm.handleAddNew,"doEdit":_vm.handleEdit,"search":_vm.handleSearch,"doDelete":_vm.handleDeletes}})],1)],1),_c('spec-modal',{ref:"specModal",on:{"submit:success":_vm.addSpecProductUnit}}),_c('spec-feature-modal',{ref:"specFeatureModal"}),_c('product-info-modal',{ref:"productInfoModal",on:{"reloadProductInfo":function($event){return _vm.$emit('reloadProductInfo')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }